import { render, staticRenderFns } from "./GpsRankingSection.vue?vue&type=template&id=48ddb986&scoped=true"
import script from "./GpsRankingSection.vue?vue&type=script&lang=ts"
export * from "./GpsRankingSection.vue?vue&type=script&lang=ts"
import style0 from "./GpsRankingSection.vue?vue&type=style&index=0&id=48ddb986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddb986",
  null
  
)

export default component.exports